import { render, staticRenderFns } from "./settlementClaims.vue?vue&type=template&id=6bcb14e5&scoped=true&"
import script from "./settlementClaims.vue?vue&type=script&lang=js&"
export * from "./settlementClaims.vue?vue&type=script&lang=js&"
import style0 from "./settlementClaims.vue?vue&type=style&index=0&id=6bcb14e5&prod&lang=scss&scoped=true&"
import style1 from "./settlementClaims.vue?vue&type=style&index=1&id=6bcb14e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb14e5",
  null
  
)

export default component.exports